import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white" }
const _hoisted_2 = { class: "flex-1 flex flex-col overflow-y-auto px-2 py-5" }
const _hoisted_3 = {
  class: "flex-1 bg-white space-y-1",
  "aria-label": "Sidebar"
}
const _hoisted_4 = ["to"]
const _hoisted_5 = { class: "flex-1 text-sm font-medium" }
const _hoisted_6 = { class: "flex-1 text-sm font-medium" }

import { ref } from "vue"
import { useRoute } from "vue-router"
import GgmsDisclosureForNavigation from "@/components/GgmsDisclosureForNavigation.vue"
import GgmsAgencySelect from "@/components/GgmsAgencySelect.vue"
import { useNavigationSidebarStore } from "@/stores/navigation-sidebar"
import { NavigationChildItem, NavigationItem } from "@/shared/models/navigation"

interface Props {
    items: NavigationItem[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsNavigation',
  props: {
    items: {}
  },
  setup(__props: any) {

const route = useRoute()

const navigationSidebarStore = useNavigationSidebarStore()

const props = __props

const disclosures = ref([] as any[])

function getParentIconClass(isOpen: boolean) {
    return isOpen ? "stroke-primary-color-600" : "stroke-gray-400 group-hover:stroke-gray-500"
}

function getParentIconStroke(isOpen: boolean) {
    return isOpen ? "stroke-primary-color-600" : "stroke-gray-400 group-hover:stroke-gray-500"
}

function getParentTextClass(isOpen: boolean) {
    return isOpen ? "text-primary-color-600" : ""
}

function getClassesItem(item: NavigationItem) {
    return [
        checkActiveRoute(item.path as string)
            ? "bg-primary-color-600 text-white hover:bg-primary-color-700"
            : "text-gray-600 hover:text-gray-900 hover:bg-gray-50",
        "group flex items-center text-sm font-medium rounded-md",
    ]
}

function getClassesChildItem(item: NavigationChildItem) {
    return [
        checkActiveRoute(item.path as string)
            ? "bg-primary-color-600 text-white hover:bg-primary-color-700"
            : "text-gray-600 hover:text-gray-900 hover:bg-gray-50",
        "group flex items-center px-10 py-2 text-sm font-medium rounded-md",
    ]
}

function getClassesIcon(item: NavigationItem) {
    return [
        checkActiveRoute(item.path as string) ? "text-white" : "text-gray-400 group-hover:text-gray-500",
        "mr-3 flex-shrink-0 h-6 w-6",
    ]
}

function checkActiveRoute(path: string) {
    return route.path === path || route.path.includes(path)
}

function closeDisclosure(index?: number) {
    navigationSidebarStore.toggleSidebar(false)
    disclosures.value.forEach((disclosure, disclosureIndex) => {
        if (disclosureIndex === index) {
            return
        }
        disclosure?.closeDisclosure()
    })
}

function getItemPath(item: NavigationItem) {
    return item?.path || ""
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(GgmsAgencySelect),
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            to: item.path,
            key: item.name,
            class: _normalizeClass(getClassesItem(item))
          }, [
            (item.children)
              ? (_openBlock(), _createBlock(GgmsDisclosureForNavigation, {
                  key: item.name,
                  ref_for: true,
                  ref: (el) => (disclosures.value[index] = el),
                  "children-items": item.children,
                  class: "flex w-full space-y-1"
                }, {
                  header: _withCtx(({ isOpen }) => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                      class: _normalizeClass([getClassesIcon(item), getParentIconClass(isOpen)]),
                      stroke: getParentIconStroke(isOpen),
                      "aria-hidden": "true"
                    }, null, 8, ["class", "stroke"])),
                    _createElementVNode("span", {
                      class: _normalizeClass(["flex-1 self-center text-sm font-medium", getParentTextClass(isOpen)])
                    }, _toDisplayString(item.name), 3)
                  ]),
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        to: child.path,
                        key: child.name,
                        class: _normalizeClass(getClassesChildItem(child)),
                        onClick: ($event: any) => (closeDisclosure(index))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(child.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class", "onClick"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["children-items"]))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: getItemPath(item),
                  class: "flex w-full items-center px-2 py-2",
                  onClick: closeDisclosure
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                      class: _normalizeClass(getClassesIcon(item)),
                      "aria-hidden": "true"
                    }, null, 8, ["class"])),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ], 10, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}
}

})